import { zIndex } from '@billy/design-system'
import styled from '@emotion/styled'

export const SuppliersBalanceTableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: var(--lumen-padding-24);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-x: auto;
  overflow-y: hidden;

  > div {
    min-height: 0;
    max-height: 100%;
  }

  tbody tr[role='button'] {
    cursor: pointer;
  }

  tr[data-totals-row] td {
    position: sticky;
    bottom: 0;
    z-index: ${zIndex.TableStickyHeader};
    background-color: var(--lumen-color-surface-neutral-subtle-default);
    box-shadow: inset 0 1px 0 var(--lumen-color-border-neutral-subtle);
  }
`
